import { CmsApiAnchorBlockData } from 'modules/cms/api/types/CmsApiAnchor';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAnchorBlock } from './CmsAnchorBlock';

export const CmsAnchorBlockMapping: CmsBlockMapping<CmsApiAnchorBlockData> = {
  invariant: [
    {
      prop: 'anchor',
      msg: 'Anchor required for anchor',
    },
  ],
  width: CmsBlockWidth.GRID,
  Component: CmsAnchorBlock,
  // @ts-expect-error TS(2322): Type 'null' is not assignable to type '(props: Cms... Remove this comment to see the full error message
  AmpComponent: null,
};
